import { getDefaultTime } from '@/pages/intelligence/utils/topchartsUtils';

interface FetchParams {
  [key: string]: any;
}
interface UpdateFetchParamsOptions {
  fetchParams: FetchParams;
  startDate: string | null | undefined;
  endDate: string | null | undefined;
  period: string;
  isTwoMonths?: boolean;
}
export const updateDefaultTimeParams = (
  options: UpdateFetchParamsOptions,
): FetchParams => {
  let newFetchParams = { ...options.fetchParams };

  if (options.startDate && options.endDate) {
    newFetchParams.start_date = options.startDate;
    newFetchParams.end_date = options.endDate;
  } else {
    const [defautStart, defautEnd] = getDefaultTime(
      options.period,
      options.isTwoMonths,
    );
    newFetchParams.start_date = defautStart;
    newFetchParams.end_date = defautEnd;
  }

  return newFetchParams;
};
